
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.5","cy":"12","r":"12","fill":"#1C0630"}}),_c('rect',{attrs:{"x":"11.3","y":"6","width":"2.4","height":"12","rx":"1.2","fill":"#F8BF1E"}}),_c('rect',{attrs:{"x":"18.5","y":"10.8","width":"2.4","height":"12","rx":"1.2","transform":"rotate(90 18.5 10.8)","fill":"#F8BF1E"}})])
          )
        }
      }
    